import { Typography } from '@mui/material';

export const BoldSubHeading = function ({ text }: { text: string }) {
  return (
    <Typography
      variant="h3"
      component="h3"
      width={'100%'}
      fontSize="0.875rem"
      fontWeight={700}
      marginBottom="16px"
    >
      {text}
    </Typography>
  );
};
